import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface UploadStatus {
  state: 'idle' | 'uploading' | 'success' | 'error';
  message?: string;
  error?: any;
}

export interface UploadStep {
  number: number;
  label: string;
}

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss']
})
export class UploadModalComponent {
  @Input() visible: boolean = false;
  @Input() title: string = '';
  @Input() steps: UploadStep[] = [];
  @Input() activeStep: number = 0;
  @Input() uploadStatus: UploadStatus = { state: 'idle' };
  @Input() uploadProgress: number = 0;
  @Input() previewComponent: any; // Component to render in preview
  @Input() previewData: any; // Data to pass to preview component
  @Input() canProceed: boolean = true;
  @Input() showCloseButton: boolean = true;
  @Input() primaryButtonLabel: string = 'Next';
  @Input() style: any = { width: '600px' };
  @Input() contentStyle: any = { padding: '0' };

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() finish = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();

  showBackButton(): boolean {
    return true;
  }

  isBackButtonDisabled(): boolean {
    // Disable on first step, during upload, or after successful upload
    return this.activeStep === 0 || 
           this.uploadStatus.state === 'uploading' || 
           this.uploadStatus.state === 'success';
  }

  onBackClick(event: Event) {
    // Prevent click if button should be disabled
    if (!this.isBackButtonDisabled()) {
      this.back.emit();
    }
    // Always prevent event propagation
    event.stopPropagation();
  }

  getNextIcon(): string {
    if (this.uploadStatus.state === 'success') {
      return 'pi pi-check';
    }
    return this.activeStep === this.steps.length - 1 ? 'pi pi-upload' : 'pi pi-chevron-right';
  }

  closeModal() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.close.emit();
  }
} 